import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initSentry } from './observability/sentry'
import { installStaleChunkReloadHandler } from './shared/utils/dynamicImport'
import { AuthProvider } from './shared/context/AuthContext'
import { LanguageProvider } from './shared/context/LanguageContext'
import { EditorProvider } from './shared/context/EditorContext'
import '@fontsource/manrope/200.css'
import '@fontsource/manrope/300.css'
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'
import '@fontsource/manrope/800.css'
import '@fontsource/arimo/400.css'
import '@fontsource/arimo/700.css'
import '@fontsource/tinos/400.css'
import '@fontsource/tinos/700.css'
import '@fontsource/cousine/400.css'
import '@fontsource/cousine/700.css'
import '@fontsource/carlito/400.css'
import '@fontsource/carlito/700.css'
import '@fontsource/lora/400.css'
import '@fontsource/lora/700.css'
import '@fontsource/open-sans/300.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/open-sans/800.css'
import './config/i18n'
import './index.css'
// Hoja de marca por defecto. Define las variables --primary-* para los temas
// claro y oscuro. Si VITE_BRAND_NAME apunta a otra marca, BrandProvider carga
// dinámicamente su CSS (que prevalece por cascada al ir después en el <head>).
import './brands/ainovis.css'
import App from './App.tsx'

initSentry()
installStaleChunkReloadHandler()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <EditorProvider>
            <App />
          </EditorProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>,
)
